import React from "react";
import { Field } from "formik";
import { Textarea } from "../../native";

export default props => (
  <Field
    name={props.name}
    render={({ field, form: { touched, errors } }) => {
      const error = errors[field.name];
      const isDirty = touched[field.name];
      return <Textarea error={isDirty && error} {...field} {...props} />;
    }}
  />
);



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/Textarea/index.js